module.exports = __webpack_public_path__ + "static/media/hamburger.2d84ad19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assests/img/hamburger.png
// module id = 731
// module chunks = 0